// src/components/dcReturnsModal.jsx
import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

const DcReturnsModal = ({ showModal, closeModal, branch, onSelectItem }) => {
  useAuthRedirect();

  const [searchTerm, setSearchTerm] = useState("");
  const [rows, setRows] = useState([]);   // one row per DC
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!showModal) return;

    const fetchDCs = async () => {
      setLoading(true);
      try {
        const res = await axios.get("https://rfs2.infraconsoft.net.in/api/dcReturn_Modal", {
          params: { branchcode: branch },
        });

        const data = Array.isArray(res.data) ? res.data : [];
        setRows(data);
      } catch (err) {
        console.error("Error fetching DCs for modal:", err);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDCs();
    setSearchTerm(""); // clear search each time modal opens
  }, [showModal, branch]);

  const q = searchTerm.trim().toLowerCase();
  const filtered = !q
    ? rows
    : rows.filter((r) =>
        String(r.dcNo ?? "").toLowerCase().includes(q) ||
        String(r.supplierName ?? "").toLowerCase().includes(q) ||
        String(r.refNo ?? "").toLowerCase().includes(q)
      );

  const formatDate = (val) => {
    if (!val) return "";
    const d = new Date(val);
    return isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB");
  };

  const handlePick = (row) => {
    // Pass only the DC number back
    onSelectItem({ dcdetail_number: row.dcNo });
    closeModal();
  };

  if (!showModal) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <h3 className="modal-title">Delivery Challan - Select View</h3>

        <div className="search-filter">
          <p>Search Supplier:</p>
          <input
            type="text"
            className="search-input"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by DC No / Supplier / Ref No..."
          />
        </div>

        <div className="search-results">
          <table>
            <thead>
              <tr>
                <th>DC No</th>
                <th>DC Date</th>
                <th>Supplier</th>
                <th>Ref. No</th>
                <th>Ref. Date</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="6" className="loading-text">Loading...</td>
                </tr>
              ) : filtered.length > 0 ? (
                filtered.map((row) => (
                  <tr key={row.dcNo}>
                    <td>{row.dcNo}</td>
                    <td>{formatDate(row.dcDate)}</td>
                    <td>{row.supplierName}</td>
                    <td>{row.refNo}</td>
                    <td>{formatDate(row.refDate)}</td>
                    <td>
                      <button
                        className="select-btn"
                        onClick={() => handlePick(row)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No results found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <button className="close-btn" onClick={closeModal}>Close</button>
      </div>
    </div>
  );
};

export default DcReturnsModal;
